import gql from 'graphql-tag';
const DUMP_THE_COMBO_ACTIVITY_FRAGMENT = gql `
  fragment DumpTheComboActivityFragment on DumpTheComboActivity {
    targetKey
    rounds {
      id
      letterCombo
      wordPart
      steps {
        id
        answer
      }
    }
  }
`;
export default DUMP_THE_COMBO_ACTIVITY_FRAGMENT;
